import { TicketLabel } from "shared/types/helpdesk";
import { PickerItemProps } from "../../types";
import { getHelpdeskLabelIconAndColor } from "../../utils/labelConfig";

export const HelpdeskLabelItem = ({ item, isSelected, onSelect }: PickerItemProps<TicketLabel>) => {
  const labelConfig = getHelpdeskLabelIconAndColor(item);

  return (
    <button
      onClick={() => onSelect(item)}
      className={`w-full text-left px-4 py-3 rounded-lg text-sm transition-all duration-200 ease-in-out flex items-center gap-3 hover:scale-[1.01] active:scale-[0.99] border shadow-sm hover:shadow-md ${
        isSelected
          ? "bg-moss-primary/10 text-moss-primary border-moss-primary/40 ring-2 ring-moss-primary/20"
          : `${labelConfig.bgColor} ${labelConfig.textColor} border-current/20 hover:border-current/40 hover:ring-2 hover:ring-current/10`
      }`}
    >
      <div className="shrink-0">{labelConfig.icon}</div>
      <span className="font-semibold flex-1">{item}</span>
    </button>
  );
};